import { validateMod10, validateMod11 } from './kidModulo';

export const validKidModulo = (kid: string) => validateMod11(kid) || validateMod10(kid);
